<template>
  <adminTable
    ref="adminTableRef"
    :tableLoading="tableLoading"
    :totalList="totalList"
    v-model:page="page"
    v-model:limit="limit"
    v-model:searchForm="searchForm"
    :tableData="tableData"
    @search="getList"
  >
    <template v-slot:form-inline-items>
      <el-form-item>
        <el-input v-model="searchForm.title" placeholder="搜索标题" clearable />
      </el-form-item>
    </template>
    <template v-slot:query-button-right>
      <el-button
        type="primary"
        icon="CirclePlus"
        @click="editItem('add', {})"
        v-permission
        >添加</el-button
      >
    </template>
    <template v-slot:table>
      <el-table-column prop="id" label="ID" width="60" />
      <el-table-column prop="title" label="类型名称" width="150" />
      <el-table-column prop="code" label="支付编码" width="150" />
      <el-table-column prop="status" label="状态" width="150">
        <template #default="scope">
          {{ getLabelByVal(scope.row.status, openEnums) }}
          <el-switch
            v-permission
            :loading="scope.row.loading"
            @change="switchChange(scope.row)"
            :active-value="0"
            :inactive-value="1"
            v-model="scope.row.status"
          />
        </template>
      </el-table-column>

      <el-table-column prop="create_at" label="添加时间" width="160" />
      <el-table-column prop="update_at" label="更新时间" width="160" />

      <el-table-column
        label="操作"
        width="200"
        fixed="right"
        
      >
        <template #default="scope">
          <el-button
            type="primary"
            icon="Edit"
            v-permission
            @click="editItem('edit', scope.row)"
            >编辑</el-button
          >
          <el-button
            type="danger"
            icon="Delete"
            v-permission
            @click="deleteAction(scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </template>
    <el-dialog v-model="dialogFlag" title="新增/编辑" width="1100">
      <editPop :key="editRow" ref="editFormRef" :item="editRow" />

      <template #footer>
        <div class="dialog-footer">
          <el-button @click="dialogFlag = false">关闭</el-button>
          <el-button type="primary" @click="submitForm"> 保存 </el-button>
        </div>
      </template>
    </el-dialog>
  </adminTable>
</template>

<script setup>
import { ref, getCurrentInstance, onMounted } from "vue";
import { openEnums, getLabelByVal } from "@/config/enums";
import EditPop from "./components/paymentUpper/editPop.vue";
import { ElMessage, ElMessageBox } from "element-plus";

const currentUser = JSON.parse(sessionStorage.getItem("currentUser"));
const searchForm = ref({
  title: "",
});
const dialogFlag = ref(false);
const editRow = ref({});
const editFormRef = ref(null);
const adminTableRef = ref(null);
const formType = ref("add");

onMounted(() => {
  getList();
});

const editItem = (type, row = {}) => {
  formType.value = type;
  editRow.value = row;
  dialogFlag.value = true;
};

const switchChange = async (row) => {
  row.loading = true;
  const res = await proxy.$http({
    method: "post",
    url: "PaymentUpper/updatePaymentUpper",
    data: {
      status: row.status,
      id: row.id,
    },
  });
  row.loading = false;
  if (res.code != 0) {
    row.status == 1 ? (row.status = 0) : (row.status = 1);
  }
};

const submitForm = async () => {
  const url =
    formType.value == "add"
      ? "PaymentUpper/addPaymentUpper"
      : "PaymentUpper/updatePaymentUpper";
  const data = editFormRef.value.form;
  if (formType.value == "add") {
    data.id = null;
  }
  const res = await proxy.$http({
    method: "post",
    url: url,
    data: {
      title: data.title,
      code: data.code,
      status: data.status,
      id: data.id,
    },
  });

  if (res.code == 0) {
    dialogFlag.value = false;
    getList();
    ElMessage({
      type: "success",
      message: res.msg,
    });
  } else {
    dialogFlag.value = false;
    ElMessage({
      type: "error",
      message: res.msg,
    });
  }
};

const deleteAction = (row) => {
  ElMessageBox.confirm("是否删除?", "Warning", {
    confirmButtonText: "确认",
    cancelButtonText: "取消",
    type: "warning",
  })
    .then(async () => {
      const res = await proxy.$http({
        method: "get",
        url: "PaymentUpper/deletePaymentUpper?id=" + row.id,
      });
      if (res.code == 0) {
        getList();
      }
      ElMessage({
        type: "success",
        message: res.msg,
      });
    })
    .catch(() => {
      ElMessage({
        type: "info",
        message: "取消删除",
      });
    });
};

const { proxy } = getCurrentInstance();

const tableData = ref([]);
const page = ref(1);
const limit = ref(10);
const totalList = ref(0);
const tableLoading = ref(false);

const getList = async () => {
  tableLoading.value = true;
  const res = await proxy.$http({
    type: "get",
    url: "/PaymentUpper/getPaymentUpperLists",
    params: {
      page: page.value,
      limit: limit.value,
    },
  });
  tableLoading.value = false;
  if (res.code == 0) {
    tableData.value = res.data.data;
    tableData.value.map((item) => {
      item.loading = false;
    });
    totalList.value = res.data.total;
  }
};
</script>

<style lang="less" scoped></style>
